export const CONTACT = {
  email: 'service@pinbar.tw',
  address: null,
  phone: ['02-7755-7130', '+886277557130'],
  time: '週一至週五上午10點至下午7點（例假日休息）',
};

export const ORDER_STATUS = {
  waiting: 'waiting',
  done: 'done',
  canceled: 'canceled',
  // {record.status === 'waiting' && '未處理'}
  // {record.status === 'done' && '已完成'}
  // {record.status === 'canceled' && '已取消'}
};

export const ORDER_STATUS_DISPLAY = {
  waiting: {
    key: 'waiting',
    label: '未處理',
  },
  done: {
    key: 'done',
    label: '已完成',
  },
  canceled: {
    key: 'canceled',
    label: '已取消',
  },
};

export const PIXELIFY_WARNING = {
  title: '關於圖片大小',
  content:
    '為維持印刷品質，系統將檢查您的圖片解析度。\n' +
    '若您的圖片解析度不足 (如較小或需要補背景色)，\n' +
    '歡迎與我們聯繫，我們會為您做圖片調整。\n' +
    'pinbar@eculture.tech\n' +
    '02-7729-5130 #301',
};

export const THEME_COLOR = '#C3AAD1';
